'use client';

import { AppBar } from '~/components';

export default function ShopLayout({ children }: { children: React.ReactNode }) {
  return (
    <>
      <AppBar actions={['home', 'search']} />
      {children}
    </>
  );
}
